import { render } from "./associationManagement.vue?vue&type=template&id=8c100410&scoped=true"
import script from "./associationManagement.vue?vue&type=script&lang=js"
export * from "./associationManagement.vue?vue&type=script&lang=js"

import "./associationManagement.vue?vue&type=style&index=0&id=8c100410&lang=scss&scoped=true"
import "./associationManagement.vue?vue&type=style&index=1&id=8c100410&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c100410"]])

export default __exports__